import type { SeoNavbarAjax } from './seo-navbar.backend-model';
import type { SeoNavbar } from './seo-navbar.model';

export function transformSeoNavbar(response: SeoNavbarAjax): SeoNavbar {
  return response;
}
